export const CountyIcon = (props) => (
  <svg fill="none" height={18} viewBox="0 0 18 18" width={18} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M3.94038 7.48132L12.6854 3.31732C13.9604 2.70982 15.2909 4.04107 14.6841 5.31682L10.5201 14.0611C9.95088 15.2558 8.22588 15.1823 7.76088 13.9426L6.99138 11.8883C6.91619 11.6879 6.79898 11.5059 6.64763 11.3546C6.49627 11.2032 6.31428 11.086 6.11388 11.0108L4.05888 10.2406C2.81988 9.77557 2.74563 8.05057 3.94038 7.48132Z"
      stroke="#A0A5AF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
